import React from 'react';
import ProductPageTemplate from '../../components/ProductPageTemplate';

const DATA = {
  hero: {
    label: 'AI Video Interviews',
    title: 'Conduct stellar technical interviews at scale',
    subtitle: 'Three interview templates — Technical, Behavioral, Situational — powered by AI. Candidates answer via webcam, AI transcribes and scores every response.',
    gradient: 'linear-gradient(150deg, #0076A3 0%, #234E7A 50%, #0076A3 100%)',
  },
  sections: [
    {
      label: 'Interview Templates',
      title: 'Choose the right interview for every role',
      features: [
        { icon: '💻', title: 'Technical Interview', desc: 'Deep-dive into system design, coding ability, and technical problem-solving. AI evaluates depth of knowledge and code quality.' },
        { icon: '🤝', title: 'Behavioral Interview', desc: 'Assess teamwork, leadership, conflict resolution, and communication skills with structured behavioral questions.' },
        { icon: '💡', title: 'Situational Interview', desc: 'Evaluate decision-making, prioritization, and stakeholder management with real-world scenario questions.' },
      ],
      columns: 3,
    },
    {
      label: 'AI-Powered Scoring',
      title: 'Let AI evaluate depth, relevance, and quality',
      desc: 'Every interview is transcribed in real-time. AI scores each answer on a 1-10 scale with detailed feedback, strengths, and areas for improvement.',
      bullets: ['Real-time speech-to-text transcription', 'Per-question scoring with rubric', 'Communication, technical depth, and cultural fit scores', 'Overall recommendation: Advance / Consider / Pass', 'Complete interview summary for recruiters'],
      visual: '🎥',
      visualLabel: 'AI Interview Scoring Dashboard',
    },
    {
      label: 'No Installation Required',
      title: 'Candidates join interviews in-browser',
      desc: 'No downloads, no plugins. Candidates click a link, enable their webcam, and start answering questions. Works on any modern browser.',
      bullets: ['WebRTC-powered video and audio capture', 'Speech recognition with manual typing fallback', 'Progressive question difficulty', 'Anti-cheating: tab-switch detection + face monitoring', 'Shareable candidate join links'],
      visual: '🌐',
      visualLabel: 'Browser-Based Interview Room',
    },
  ],
  testimonial: { quote: 'We replaced our entire first-round interview process with CHIRE. The AI summaries are so detailed that hiring managers can make decisions without watching recordings.', name: 'Michael R.', role: 'HR Director, FinanceHub' },
  cta: { title: 'Transform your interview process', desc: 'Create your first AI interview in minutes. Candidates get a link, you get scored transcripts.' },
};

export default function InterviewsPage() { return <ProductPageTemplate data={DATA} />; }
